export class UserDefineds {
  Type1: UserDefined[];
  Type2: UserDefined[];
}

export class UserDefined {
  Id?: number;
  SUid?: string;
  Name1?: string;
  Name2?: string;
  isChecked?: boolean;

  constructor(type?: Partial<UserDefined>) {
    if (type) {
      Object.assign(this, type);
    }
  }
}

export class UserDefinedsDelete {
  UserDefindIds?: number[];
  Type?: number;
}

export class UserDefinedsDeleteResult {
  Result?: DeleteResult[];
  Type?: number;
}

export class DeleteResult {
  Id?: number;
  RefsCount?: number;
  Status?: number;
}
